export enum Roles {
  All = "ROLE_ADMIN_ALL",
  Users = "ROLE_ADMIN_USERS",
  Restaurants = "ROLE_ADMIN_VENUES",
  Beacons = "ROLE_ADMIN_BEACONS",
  PromoCodes = "ROLE_ADMIN_PROMO_CODES",
  Partnerships = "ROLE_ADMIN_PARTNERSHIPS",
  UiSettings = "ROLE_ADMIN_ORG_UI_SETTINGS",
  Analytics = "ROLE_ADMIN_ANALYTICS",
  EmailTemplates = "ROLE_ADMIN_EMAIL_TEMPLATES",
  MemberCardTypes = "ROLE_ADMIN_MEMBER_CARD_TYPES",
  ManageAdminsInOrg = "ROLE_ADMIN_MNG_ADMINS_IN_ORG",
  Shop = "ROLE_ADMIN_SHOP",
  ManageOrg = "ROLE_ADMIN_MANAGE_ORG",
  VoucherStacks = "ROLE_ADMIN_VOUCHER_STACKS",
  DeliveryRules = "ROLE_ADMIN_DELIVERY_RULES",
  Challenges = "ROLE_ADMIN_CHALLENGES",
  Integrations = "ROLE_ADMIN_INTEGRATIONS",
  TargetedCampaigns = "ROLE_ADMIN_TARGETED_CAMPAIGNS",

  // Temporary role for menus
  Menus = "ROLE_ADMIN_MENUS",

  // manage admin access to orgs
  SuperAdmin = "ROLE_ADMIN_SUPER_ADMIN",

  // other roles
  Heaps = "ROLE_HEAPS",
  User = "ROLE_USER",
  SignedUp = "ROLE_SIGNED_UP",
}
